export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14837.577c906c.jpg";